import { Card } from "react-native-paper";
import type { MixedItemTag } from "../../../types";
import Button from "../../Button";
import CardContainer from "../../CardContainer";
import CardSkeleton from "../../Skeletons/CardSkeleton";
import ItemsListItem from "./ItemsListItem";

type ItemsListitemProps = {
	id: number;
	tags: MixedItemTag[];
	index: number;
	title: string;
	answerStatus: "correct" | "incorrect" | "skipped";
	marked?: boolean;
};
export type StudySessionItemsPerformanceCardProps = {
	title: string;
	subtitle: string;
	items: ItemsListitemProps[];
	handleClickCard: () => void;
	loading?: boolean;
};
const StudySessionItemsPerformanceCard = ({
	title,
	subtitle,
	items,
	handleClickCard,
	loading,
}: StudySessionItemsPerformanceCardProps) => {
	if (loading) {
		return <CardSkeleton numRows={3} />;
	}

	return (
		<CardContainer
			title={title}
			subtitle={subtitle}
			icon="arm-flex-outline"
			onPress={handleClickCard}
			actions={
				<Card.Actions>
					<Button onPress={handleClickCard} mode="text">
						View responses
					</Button>
				</Card.Actions>
			}
		>
			<Card.Content style={{ paddingLeft: 4, paddingRight: 0, paddingTop: 8 }}>
				{items.slice(0, 3).map((item) => (
					<ItemsListItem key={item.id} {...item} />
				))}
			</Card.Content>
		</CardContainer>
	);
};

export default StudySessionItemsPerformanceCard;
